import { z } from "zod";
import { isEmail } from "validator";

export const ContactSchema = z.object({
	name: z.string().min(3, "Should contain min of 3 characters!").max(50, "Should contain max of 50 characters!"),
	email: z.string().refine(data => isEmail(data), "Invalid email!"),
	message: z.string().min(10, "Should contain min of 10 characters!").max(1000, "Should contain max of 1000 characters!"),
});
